import React, {useEffect, useState} from 'react';
import IncidentsReportOptionsForm from './options/IncidentsReportOptionsForm';
import DataTable from '../../components/reports/DataTable';
import DownloadButton from '../../components/reports/DownloadButton';
import OutletIcon from "@mui/icons-material/Outlet";

import {Box, Grid, Typography, } from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import "@fontsource/roboto";

const IncidentsReport = () => {

    const [options, setOptions] = useState([]);
    const [data, setData] = useState([]);
    const [name, setName] = useState('IncidentsReport');

    useEffect(() => {
        if (options.start_date != undefined && options.end_date != undefined){
            setName(`IncidentsReport ${options.start_date}  ${options.end_date}`);
        }
    }, [options]);

    return (
        <div>
            <Grid container spacing={2}
                  sx={{
                      padding: 2,
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '4px',
                      paddingLeft: 0,
                      paddingTop: 0,
                      marginLeft: '-10px',
                      marginTop: '-5px',
                      boxShadow: '0 0 10px rgba(0, 0, 0, 0.08)',
                  }}
            >
                <Grid item xs={12} md={12} sx={{width: "100%"}}>
                    <Accordion sx={{width: "100%"}}>
                        <AccordionSummary
                            expandIcon={<InfoOutlinedIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            sx={{
                                backgroundColor: '#f0f3f5',
                                width: "100%",
                                height: '35px !important',
                                minHeight: '25px !important',
                            }}
                        >
                            Explanations
                        </AccordionSummary>
                        <AccordionDetails sx={{width: "100%"}}>
                            <Box>
                                <Typography variant="subtitle1" sx={{ marginBottom: '1rem' }}>
                                    📊 Incidents Report Options and Functionalities
                                </Typography>

                                <Typography variant="body1" sx={{ marginBottom: '1rem', marginLeft: '1rem' }}>
                                    This report shows GeoEdge blocking incidents received via the Incident Detection
                                    Callback and stored in our system. Select data and statistics fields, choose a time
                                    interval, apply DSP/Publisher filters and a date range, then generate the report.
                                </Typography>

                                <Typography variant="subtitle1" sx={{ marginBottom: '0.5rem' }}>
                                    ⚙️ Data Selection:
                                </Typography>
                                <Typography variant="body1" sx={{ marginBottom: '1rem', marginLeft: '1rem' }}>
                                    Select specific data fields (Trigger Type, Trigger Category, DSP, Publisher, etc.)
                                    to include in the report by checking the corresponding checkboxes.
                                </Typography>

                                <Typography variant="subtitle1" sx={{ marginBottom: '0.5rem' }}>
                                    📈 Statistics Selection:
                                </Typography>
                                <Typography variant="body1" sx={{ marginBottom: '1rem', marginLeft: '1rem' }}>
                                    Select statistics fields such as Incident Count and Blocked Count to aggregate.
                                </Typography>

                                <Typography variant="subtitle1" sx={{ marginBottom: '0.5rem' }}>
                                    ⏲️ Time Interval Selection:
                                </Typography>
                                <Typography variant="body1" sx={{ marginBottom: '1rem', marginLeft: '1rem' }}>
                                    Choose the time interval for the report: day, week or month.
                                </Typography>

                                <Typography variant="subtitle1" sx={{ marginBottom: '0.5rem' }}>
                                    📅 Date Range Selection:
                                </Typography>
                                <Typography variant="body1" sx={{ marginBottom: '1rem', marginLeft: '1rem' }}>
                                    Select a date range using the "Date Range" dropdown calendar.
                                </Typography>
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                </Grid>


            </Grid>

            <Grid container spacing={2}
                  sx={{
                      padding: 2,
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '4px',
                      paddingLeft: 0,
                      marginLeft: '-10px',
                      marginTop: '20px',
                      boxShadow: '0 0 10px rgba(0, 0, 0, 0.08)',
                  }}
            >
                <Grid item xs={12} md={12} sx={{width: "100%"}}>
                    <IncidentsReportOptionsForm onGenerate={setData} getOptions={setOptions}/>
                </Grid>
                <Grid item xs={12} md={12}>
                    {data.length != 0 && <DownloadButton
                        data={data}
                        label={name}
                        sx={{float: 'right',}}
                    />}
                </Grid>
                <Grid item xs={12} md={12}>
                    {data === false ? (
                        <Typography variant="h4" component="h2" align="center"><OutletIcon
                            fontSize="large"/> NO DATA </Typography>
                    ) : (
                        <DataTable data={data}/>
                    )}
                </Grid>
            </Grid>
        </div>
    );
};

export default IncidentsReport;
